module.exports = __webpack_public_path__ + "img/41.d1d1a515.png";